import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "./ui/accordion";
import { Phone } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { FAQS, PHONE_DISPLAY, PHONE_TEL } from "../constants/content";

export const Faq = () => (
    <section id="faq" className="relative bg-white noise-overlay">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 py-24 lg:py-32">
            <Reveal className="text-center">
                <Eyebrow>Some of our F.A.Q.</Eyebrow>
                <h2 className="mt-4 font-display font-extrabold uppercase tracking-tight text-2xl sm:text-3xl lg:text-4xl text-[#141721] leading-tight">
                    The questions <span className="text-[#FF3B30]">everyone asks.</span>
                </h2>
                <p className="mt-5 text-sm text-[#565B6B]">
                    Can&apos;t find your answer? Call{" "}
                    <a href={PHONE_TEL} data-testid="faq-call-link" className="text-[#FF3B30] font-semibold hover:underline">
                        {PHONE_DISPLAY}
                    </a>{" "}
                    and we&apos;ll sort you out right away.
                </p>
            </Reveal>

            <Reveal delay={0.15}>
                <Accordion type="single" collapsible className="mt-12 space-y-3">
                    {FAQS.map((faq, i) => (
                        <AccordionItem
                            key={i}
                            value={`item-${i}`}
                            data-testid={`faq-accordion-item-${i}`}
                            className="rounded-lg border border-[#E3E3DE] bg-[#F4F4F2] px-6 transition-colors duration-300 data-[state=open]:border-[#FF3B30]/60"
                        >
                            <AccordionTrigger className="py-5 text-left font-display font-semibold text-base text-[#141721] hover:text-[#FF3B30] hover:no-underline">
                                <span className="flex items-baseline gap-4">
                                    <span className="font-mono-ind text-xs font-bold text-[#FF3B30]">
                                        {String(i + 1).padStart(2, "0")}
                                    </span>
                                    {faq.q}
                                </span>
                            </AccordionTrigger>
                            <AccordionContent className="pb-6 pl-10 text-sm text-[#565B6B] leading-relaxed">
                                {faq.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </Reveal>

            <Reveal delay={0.2} className="mt-12 text-center">
                <a
                    href={PHONE_TEL}
                    data-testid="faq-call-btn"
                    className="inline-flex items-center gap-3 rounded-md border-2 border-[#FF3B30] px-8 py-4 font-display font-bold text-base text-[#FF3B30] uppercase tracking-wide transition-all duration-300 hover:bg-[#FF3B30] hover:text-[#141721]"
                >
                    <Phone className="h-5 w-5" strokeWidth={2.6} />
                    Still curious? Call {PHONE_DISPLAY}
                </a>
            </Reveal>
        </div>
    </section>
);
